<template>
  <basic-scrolling-with-gradient :has-gradient="instance.exposed.hasGradient">
    <div :class="{ 'the-grid': ['maxi'].includes(instance.exposed.size) }">
      <div
        v-if="instance.exposed.stepTitle || $slots.title"
        class="dvp-modal__title"
      >
        <template v-if="instance.exposed.stepTitle">
          <span
            :id="titleId"
            :class="{ h3: instance.exposed.size !== 'mini', 'title-1': instance.exposed.size === 'mini' }"
            v-html="instance.exposed.stepTitle"
          />
        </template>
        <template v-else>
          <div
            :id="titleId"
            :class="{ h3: instance.exposed.size !== 'mini', 'title-1': instance.exposed.size === 'mini' }"
          >
            <slot name="title" />
          </div>
        </template>
      </div>
      <div class="dvp-modal__body body-2">
        <slot />
      </div>
    </div>
  </basic-scrolling-with-gradient>
</template>

<script setup>
  import { computed, getCurrentInstance, onBeforeMount, ref } from 'vue'

  import BasicScrollingWithGradient from '@shared/components/Basic/ScrollingWithGradient'

  // DATA
  const instance = ref()

  // COMPUTED
  const titleId = computed(() => {
    return `${instance.value.exposed.id}-title`
  })

  // METHODS

  // LIFECYCLE HOOKS
  onBeforeMount(() => {
    instance.value = getCurrentInstance().parent
  })
</script>

<style scoped>
.dvp-modal__title {
  margin: 0 0 var(--dotcom-responsive-spacing-res-xxs) 0;
}

.dvp-modal--mini .dvp-modal__title {
  margin: 0 0 var(--fixed-spacing-fix-02) 0;
}

.dvp-modal--maxi .dvp-modal__title,
.dvp-modal--maxi .dvp-modal__body {
  grid-column: 1 / -1;
}
</style>
